(function () {
  var levar_activations = document.getElementsByClassName('levar-button');
  for (var i = 0; i < levar_activations.length; i++) {
    var activation = levar_activations[i];
    levar_activations[i].addEventListener('click', levarActivation);
  }

  function levarActivation(event) {
    if (document.body.classList.contains('levar_player_on')) return;
    if (activation.id === 'levar-player-mobile') {
      document.getElementById('levar-player').click();
      return;
    }
    var _learnq = _learnq || [],
        product_id = activation.dataset.productid,
        product_name = activation.dataset.productname,
        variantSelectField = document.querySelector('[name="id"]'),
        variant_id = parseInt(variantSelectField.value),
        variant_name = variantSelectField.options[variantSelectField.selectedIndex].text,
        viewer_url = "https://viewer.levar.io/?variant="+variant_id,
        event_label = activation.id === 'levar-direct-qr-button' ? 'QR - Carousel' : '3D - Carousel';
  
    var klaviyo_aritem = {
        Name: product_name,
        ProductID: product_id,
        VariantID: variant_id,
        VariantName: variant_name,
        ViewerURL: viewer_url,
        ActivationType: event_label,
    };
      
    var g4_aritem = {
        'product_name': product_name,
        'product_id': product_id,
        'variant_id': variant_id,
        'variant_name': variant_name,
        'viewer_url': viewer_url,
        'activation_type': event_label,
        'send_to': 'G-4W9WPN12CV',
    };
  
    // console.log('klaviyo_aritem', klaviyo_aritem);
    gtag('event', 'levar_activation', g4_aritem);
    _learnq.push(['track', 'LEVAR Activation', klaviyo_aritem]);
  };
})()